import React, { useContext } from 'react';
import { Copy, Optional } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import Context from '../service/Context';
import themeStyles from '../PaymentDetailsComponent.styles';
const PaymentLabelCopy = themeStyles.apply(Copy, 'PaymentLabelCopy');
const PaymentContentCopy = themeStyles.apply(Copy, 'PaymentContentCopy');
const InformationalApr = () => {
    const { t } = useTranslation();
    const { informationalApr } = useContext(Context);
    const isInformationalAprValid = typeof informationalApr === 'number' && !Number.isNaN(informationalApr);
    return (React.createElement(Optional, { when: isInformationalAprValid },
        React.createElement(PaymentLabelCopy, { size: "extraSmall", "data-testid": "cy-payment-informational-apr-label" }, t('Shared.Common.informationalAprLabel')),
        React.createElement(PaymentContentCopy, { size: "regular", "data-testid": "cy-payment-informational-apr-value" }, `${informationalApr === null || informationalApr === void 0 ? void 0 : informationalApr.toFixed(2)}%`)));
};
export default InformationalApr;
